import { BundleResourcesPackage } from "resources/BundleResourcesPackage";
import { Texture, Spritesheet } from "pixi.js";
export class CommonResourcesPackage extends BundleResourcesPackage {
    public constructor() {
        super("CommonResourcesPackage");
    }
    public get assets_common_blured_backgrounds_blurry_lobby_jpg(): Texture {
        return this.resource<Texture>("assets/common/blured_backgrounds/blurry_lobby.jpg");
    }
    public get assets_common_blured_backgrounds_blurry_map_jpg(): Texture {
        return this.resource<Texture>("assets/common/blured_backgrounds/blurry_map.jpg");
    }
    public get assets_common_favicon_png(): Texture {
        return this.resource<Texture>("assets/common/favicon.png");
    }
    public get assets_common_ui_ui_1x_atlas_json(): Spritesheet {
        return this.resource<Spritesheet>("assets/common/ui/ui_1x.atlas.json");
    }
    public get assets_common_ui_scrollbar_line_png(): Texture {
        return this.assets_common_ui_ui_1x_atlas_json.textures["scrollbar/line.png"];
    }
    public get assets_common_ui_scrollbar_line_2_png(): Texture {
        return this.assets_common_ui_ui_1x_atlas_json.textures["scrollbar/line_2.png"];
    }
    public get assets_common_ui_lights_light_left_png(): Texture {
        return this.assets_common_ui_ui_1x_atlas_json.textures["lights/light_left.png"];
    }
    public get assets_common_ui_tooltip_bg_png(): Texture {
        return this.assets_common_ui_ui_1x_atlas_json.textures["tooltip_bg.png"];
    }
    public get assets_common_ui_hand_hand_png(): Texture {
        return this.assets_common_ui_ui_1x_atlas_json.textures["hand/hand.png"];
    }
    public get assets_common_ui_tooltips_tooltip_bg_png(): Texture {
        return this.assets_common_ui_ui_1x_atlas_json.textures["tooltips/tooltip_bg.png"];
    }
    public get assets_common_ui_button_green_blue_png(): Texture {
        return this.assets_common_ui_ui_1x_atlas_json.textures["button_green_blue.png"];
    }
    public get assets_common_ui_button_green_long_png(): Texture {
        return this.assets_common_ui_ui_1x_atlas_json.textures["button_green_long.png"];
    }
    public get assets_common_ui_button_green_png(): Texture {
        return this.assets_common_ui_ui_1x_atlas_json.textures["button_green.png"];
    }
    public get assets_common_ui_button_orange_png(): Texture {
        return this.assets_common_ui_ui_1x_atlas_json.textures["button_orange.png"];
    }
    public get assets_common_ui_collect_button_collect_png(): Texture {
        return this.assets_common_ui_ui_1x_atlas_json.textures["collect_button/collect.png"];
    }
    public get assets_common_ui_dices_dice_01_png(): Texture {
        return this.assets_common_ui_ui_1x_atlas_json.textures["dices/dice_01.png"];
    }
    public get assets_common_ui_dices_dice_03_png(): Texture {
        return this.assets_common_ui_ui_1x_atlas_json.textures["dices/dice_03.png"];
    }
    public get assets_common_ui_progress_counter_bottom_progress_png(): Texture {
        return this.assets_common_ui_ui_1x_atlas_json.textures["progress_counter/bottom_progress.png"];
    }
    public get assets_common_ui_top_panel_coins_field_png(): Texture {
        return this.assets_common_ui_ui_1x_atlas_json.textures["top_panel/coins_field.png"];
    }
    public get assets_common_ui_button_green_without_shadow_png(): Texture {
        return this.assets_common_ui_ui_1x_atlas_json.textures["button_green_without_shadow.png"];
    }
    public get assets_common_ui_piggy_club_multiplier_bg_png(): Texture {
        return this.assets_common_ui_ui_1x_atlas_json.textures["piggy_club_multiplier_bg.png"];
    }
    public get assets_common_ui_progress_counter_yellow_progress_png(): Texture {
        return this.assets_common_ui_ui_1x_atlas_json.textures["progress_counter/yellow_progress.png"];
    }
    public get assets_common_ui_hint_arrow_right_png(): Texture {
        return this.assets_common_ui_ui_1x_atlas_json.textures["hint_arrow_right.png"];
    }
    public get assets_common_ui_scrollbar_lift_png(): Texture {
        return this.assets_common_ui_ui_1x_atlas_json.textures["scrollbar/lift.png"];
    }
    public get assets_common_ui_top_panel_tokens_field_png(): Texture {
        return this.assets_common_ui_ui_1x_atlas_json.textures["top_panel/tokens_field.png"];
    }
    public get assets_common_ui_top_panel_avatar_field_png(): Texture {
        return this.assets_common_ui_ui_1x_atlas_json.textures["top_panel/avatar_field.png"];
    }
    public get assets_common_ui_hint_arrow_left_png(): Texture {
        return this.assets_common_ui_ui_1x_atlas_json.textures["hint_arrow_left.png"];
    }
    public get assets_common_ui_scrollbar_lift_2_png(): Texture {
        return this.assets_common_ui_ui_1x_atlas_json.textures["scrollbar/lift_2.png"];
    }
    public get assets_common_ui_rounded_rectangle_png(): Texture {
        return this.assets_common_ui_ui_1x_atlas_json.textures["rounded_rectangle.png"];
    }
    public get assets_common_ui_shield_parts_shield_02_png(): Texture {
        return this.assets_common_ui_ui_1x_atlas_json.textures["shield_parts/shield_02.png"];
    }
    public get assets_common_ui_piggy_piggy_icon_png(): Texture {
        return this.assets_common_ui_ui_1x_atlas_json.textures["piggy/piggy_icon.png"];
    }
    public get assets_common_ui_shield_parts_shield_04_png(): Texture {
        return this.assets_common_ui_ui_1x_atlas_json.textures["shield_parts/shield_04.png"];
    }
    public get assets_common_ui_leaderboard_button_trophy_png(): Texture {
        return this.assets_common_ui_ui_1x_atlas_json.textures["leaderboard_button/trophy.png"];
    }
    public get assets_common_ui_usdc_icon_png(): Texture {
        return this.assets_common_ui_ui_1x_atlas_json.textures["usdc_icon.png"];
    }
    public get assets_common_ui_shield_parts_shield_01_png(): Texture {
        return this.assets_common_ui_ui_1x_atlas_json.textures["shield_parts/shield_01.png"];
    }
    public get assets_common_ui_discount_coupon_png(): Texture {
        return this.assets_common_ui_ui_1x_atlas_json.textures["discount_coupon.png"];
    }
    public get assets_common_ui_shield_parts_shield_03_png(): Texture {
        return this.assets_common_ui_ui_1x_atlas_json.textures["shield_parts/shield_03.png"];
    }
    public get assets_common_ui_shield_parts_shield_05_png(): Texture {
        return this.assets_common_ui_ui_1x_atlas_json.textures["shield_parts/shield_05.png"];
    }
    public get assets_common_ui_coins_random_coins_11_png(): Texture {
        return this.assets_common_ui_ui_1x_atlas_json.textures["coins/random_coins/11.png"];
    }
    public get assets_common_ui_coins_random_coins_13_png(): Texture {
        return this.assets_common_ui_ui_1x_atlas_json.textures["coins/random_coins/13.png"];
    }
    public get assets_common_ui_coins_random_coins_14_png(): Texture {
        return this.assets_common_ui_ui_1x_atlas_json.textures["coins/random_coins/14.png"];
    }
    public get assets_common_ui_coins_random_coins_15_png(): Texture {
        return this.assets_common_ui_ui_1x_atlas_json.textures["coins/random_coins/15.png"];
    }
    public get assets_common_ui_coins_random_coins_16_png(): Texture {
        return this.assets_common_ui_ui_1x_atlas_json.textures["coins/random_coins/16.png"];
    }
    public get assets_common_ui_coins_random_coins_6_png(): Texture {
        return this.assets_common_ui_ui_1x_atlas_json.textures["coins/random_coins/6.png"];
    }
    public get assets_common_ui_coins_random_coins_7_png(): Texture {
        return this.assets_common_ui_ui_1x_atlas_json.textures["coins/random_coins/7.png"];
    }
    public get assets_common_ui_coins_rotate_animation_0000_png(): Texture {
        return this.assets_common_ui_ui_1x_atlas_json.textures["coins/rotate_animation/0000.png"];
    }
    public get assets_common_ui_coins_rotate_animation_0001_png(): Texture {
        return this.assets_common_ui_ui_1x_atlas_json.textures["coins/rotate_animation/0001.png"];
    }
    public get assets_common_ui_coins_rotate_animation_0002_png(): Texture {
        return this.assets_common_ui_ui_1x_atlas_json.textures["coins/rotate_animation/0002.png"];
    }
    public get assets_common_ui_coins_rotate_animation_0003_png(): Texture {
        return this.assets_common_ui_ui_1x_atlas_json.textures["coins/rotate_animation/0003.png"];
    }
    public get assets_common_ui_coins_rotate_animation_0004_png(): Texture {
        return this.assets_common_ui_ui_1x_atlas_json.textures["coins/rotate_animation/0004.png"];
    }
    public get assets_common_ui_coins_rotate_animation_0005_png(): Texture {
        return this.assets_common_ui_ui_1x_atlas_json.textures["coins/rotate_animation/0005.png"];
    }
    public get assets_common_ui_coins_rotate_animation_0006_png(): Texture {
        return this.assets_common_ui_ui_1x_atlas_json.textures["coins/rotate_animation/0006.png"];
    }
    public get assets_common_ui_coins_rotate_animation_0007_png(): Texture {
        return this.assets_common_ui_ui_1x_atlas_json.textures["coins/rotate_animation/0007.png"];
    }
    public get assets_common_ui_coins_rotate_animation_0008_png(): Texture {
        return this.assets_common_ui_ui_1x_atlas_json.textures["coins/rotate_animation/0008.png"];
    }
    public get assets_common_ui_coins_rotate_animation_0009_png(): Texture {
        return this.assets_common_ui_ui_1x_atlas_json.textures["coins/rotate_animation/0009.png"];
    }
    public get assets_common_ui_coins_rotate_animation_0010_png(): Texture {
        return this.assets_common_ui_ui_1x_atlas_json.textures["coins/rotate_animation/0010.png"];
    }
    public get assets_common_ui_coins_rotate_animation_0011_png(): Texture {
        return this.assets_common_ui_ui_1x_atlas_json.textures["coins/rotate_animation/0011.png"];
    }
    public get assets_common_ui_coins_rotate_animation_0012_png(): Texture {
        return this.assets_common_ui_ui_1x_atlas_json.textures["coins/rotate_animation/0012.png"];
    }
    public get assets_common_ui_coins_rotate_animation_0013_png(): Texture {
        return this.assets_common_ui_ui_1x_atlas_json.textures["coins/rotate_animation/0013.png"];
    }
    public get assets_common_ui_coins_rotate_animation_0014_png(): Texture {
        return this.assets_common_ui_ui_1x_atlas_json.textures["coins/rotate_animation/0014.png"];
    }
    public get assets_common_ui_coins_rotate_animation_0015_png(): Texture {
        return this.assets_common_ui_ui_1x_atlas_json.textures["coins/rotate_animation/0015.png"];
    }
    public get assets_common_ui_coins_random_coins_10_png(): Texture {
        return this.assets_common_ui_ui_1x_atlas_json.textures["coins/random_coins/10.png"];
    }
    public get assets_common_ui_coins_random_coins_8_png(): Texture {
        return this.assets_common_ui_ui_1x_atlas_json.textures["coins/random_coins/8.png"];
    }
    public get assets_common_ui_coins_random_coins_9_png(): Texture {
        return this.assets_common_ui_ui_1x_atlas_json.textures["coins/random_coins/9.png"];
    }
    public get assets_common_ui_piggy_icon_without_mp_png(): Texture {
        return this.assets_common_ui_ui_1x_atlas_json.textures["piggy_icon_without_mp.png"];
    }
    public get assets_common_ui_coins_random_coins_12_png(): Texture {
        return this.assets_common_ui_ui_1x_atlas_json.textures["coins/random_coins/12.png"];
    }
    public get assets_common_ui_web3_thirdweb_icon_png(): Texture {
        return this.assets_common_ui_ui_1x_atlas_json.textures["web3/thirdweb_icon.png"];
    }
    public get assets_common_ui_web3_coinbase_icon_png(): Texture {
        return this.assets_common_ui_ui_1x_atlas_json.textures["web3/coinbase_icon.png"];
    }
    public get assets_common_ui_web3_metamask_icon_png(): Texture {
        return this.assets_common_ui_ui_1x_atlas_json.textures["web3/metamask_icon.png"];
    }
    public get assets_common_ui_loading_star_png(): Texture {
        return this.assets_common_ui_ui_1x_atlas_json.textures["loading/star.png"];
    }
    public get assets_common_ui_loading_crawn_png(): Texture {
        return this.assets_common_ui_ui_1x_atlas_json.textures["loading/crawn.png"];
    }
    public get assets_common_ui_loading_coin_png(): Texture {
        return this.assets_common_ui_ui_1x_atlas_json.textures["loading/coin.png"];
    }
    public get assets_common_ui_coins_random_coins_4_png(): Texture {
        return this.assets_common_ui_ui_1x_atlas_json.textures["coins/random_coins/4.png"];
    }
    public get assets_common_ui_coins_random_coins_2_png(): Texture {
        return this.assets_common_ui_ui_1x_atlas_json.textures["coins/random_coins/2.png"];
    }
    public get assets_common_ui_coins_random_coins_3_png(): Texture {
        return this.assets_common_ui_ui_1x_atlas_json.textures["coins/random_coins/3.png"];
    }
    public get assets_common_ui_coins_random_coins_5_png(): Texture {
        return this.assets_common_ui_ui_1x_atlas_json.textures["coins/random_coins/5.png"];
    }
    public get assets_common_ui_coins_random_coins_1_png(): Texture {
        return this.assets_common_ui_ui_1x_atlas_json.textures["coins/random_coins/1.png"];
    }
    public get assets_common_ui_dicre_icon_png(): Texture {
        return this.assets_common_ui_ui_1x_atlas_json.textures["dicre_icon.png"];
    }
    public get assets_common_ui_building_icon_png(): Texture {
        return this.assets_common_ui_ui_1x_atlas_json.textures["building_icon.png"];
    }
    public get assets_common_ui_top_panel_coin_png(): Texture {
        return this.assets_common_ui_ui_1x_atlas_json.textures["top_panel/coin.png"];
    }
    public get assets_common_ui_top_panel_shield_png(): Texture {
        return this.assets_common_ui_ui_1x_atlas_json.textures["top_panel/shield.png"];
    }
    public get assets_common_ui_vector_png(): Texture {
        return this.assets_common_ui_ui_1x_atlas_json.textures["vector.png"];
    }
    public get assets_common_ui_button_token_icon_png(): Texture {
        return this.assets_common_ui_ui_1x_atlas_json.textures["button_token_icon.png"];
    }
    public get assets_common_ui_indicator_point_png(): Texture {
        return this.assets_common_ui_ui_1x_atlas_json.textures["indicator_point.png"];
    }
    public get assets_common_ui_x_png(): Texture {
        return this.assets_common_ui_ui_1x_atlas_json.textures["x.png"];
    }
    public get assets_common_ui_back_png(): Texture {
        return this.assets_common_ui_ui_1x_atlas_json.textures["back.png"];
    }
    public get assets_common_ui_top_panel_humburger_png(): Texture {
        return this.assets_common_ui_ui_1x_atlas_json.textures["top_panel/humburger.png"];
    }
    public get assets_common_ui_tooltips_tooltip_pointer_png(): Texture {
        return this.assets_common_ui_ui_1x_atlas_json.textures["tooltips/tooltip_pointer.png"];
    }
    public get assets_common_ui_substract_icon_png(): Texture {
        return this.assets_common_ui_ui_1x_atlas_json.textures["substract_icon.png"];
    }
    public get assets_common_ui_box_dollar_icon_png(): Texture {
        return this.assets_common_ui_ui_1x_atlas_json.textures["box_dollar_icon.png"];
    }
    public get assets_common_ui_box_icon_png(): Texture {
        return this.assets_common_ui_ui_1x_atlas_json.textures["box_icon.png"];
    }
    public get assets_common_ui_info_icon_png(): Texture {
        return this.assets_common_ui_ui_1x_atlas_json.textures["info_icon.png"];
    }
    public get assets_common_ui_top_panel_plus_button_png(): Texture {
        return this.assets_common_ui_ui_1x_atlas_json.textures["top_panel/plus_button.png"];
    }
    public get assets_common_ui_confety_confetti_9_png(): Texture {
        return this.assets_common_ui_ui_1x_atlas_json.textures["confety/confetti_9.png"];
    }
    public get assets_common_ui_confety_confetti_10_png(): Texture {
        return this.assets_common_ui_ui_1x_atlas_json.textures["confety/confetti_10.png"];
    }
    public get assets_common_ui_confety_confetti_4_png(): Texture {
        return this.assets_common_ui_ui_1x_atlas_json.textures["confety/confetti_4.png"];
    }
    public get assets_common_ui_confety_confetti_5_png(): Texture {
        return this.assets_common_ui_ui_1x_atlas_json.textures["confety/confetti_5.png"];
    }
    public get assets_common_ui_confety_confetti_3_png(): Texture {
        return this.assets_common_ui_ui_1x_atlas_json.textures["confety/confetti_3.png"];
    }
    public get assets_common_ui_top_panel_token_icon_png(): Texture {
        return this.assets_common_ui_ui_1x_atlas_json.textures["top_panel/token_icon.png"];
    }
    public get assets_common_ui_ui_1x_atlas_png(): Texture {
        return this.resource<Texture>("assets/common/ui/ui_1x.atlas.png");
    }
    public get assets_common_x_png(): Texture {
        return this.resource<Texture>("assets/common/x.png");
    }
}

